import { NgModule } from '@angular/core';
import { FeatureFlagsModule } from 'mojo-feature-flags';

import { SharedModule } from '@app/shared';

import { LicenseConfigurationModule } from '../settings/license-configuration';

@NgModule({
  imports: [
    LicenseConfigurationModule,
    SharedModule
  ],
  exports: [FeatureFlagsModule, LicenseConfigurationModule]
})
export class SettingsModule { }
